import { jaApp, jaWebsite } from './strings';

const ja = {
  translation: {
    ...jaWebsite,
    ...jaApp
  }
};

export default ja;
